import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { PrivilegeService } from '@core/services/application/privilege/privilege.service';
import { AccessDeniedPath } from '@core/constants';

export const superAdminGuard: CanActivateFn = () => {
  const privilegeService = inject(PrivilegeService);
  const router = inject(Router);

  return privilegeService.isSuperAdmin || router.parseUrl(AccessDeniedPath);
};
